import React from "react";
import "./OurStory.css";
import img1 from "../Assets/woman.jpg";
import img2 from "../Assets/aboutgroup.jpg";

const profiles = {
  tejaswini: {
    name: "Tejaswini Fadnis",
    designation: "Founder",
    content: <><b>Tejaswini Fadnis is the Founder and the Academic Director of NewZeal Language Academy, focussing on the academic excellence of the organization.</b> <br/><br/>

Tejaswini is a dedicated <b>Spoken English Trainer and Language</b> Coach with more than 2 decades of experience in helping learners transform the way they communicate in English.<br/><br/>

<b>Over the years, she has trained students and professionals at reputed institutions including Bhasha, Prakruti Banwasi Training Institute, VETA Spoken English Centre, Triway Learning Pvt. Ltd., and Beaconhouse School, Muscat (Oman)</b><br/><br/>

Her teaching style is <b>simple, practical, and result-oriented.</b> Using a <b>bilingual approach (Kannada–English & Hindi–English),</b> she makes learning English easy and enjoyable for beginners while also challenging intermediate and advanced learners to reach new levels of fluency.<br/><br/>

<b>She specializes in:</b> <br/>
<ul>
  <li>Spoken English & Grammar Made Easy</li>
  <li>Soft Skills & Interview Preparation</li>
  <li>Confidence-Building for Career Growth</li>
  <li>Group Discussions & Employability Training</li>
</ul><br/>

<b>Tejaswini is responsible for the following areas of NewZeal:</b><br/>
<ul>
  <li>Curriculum & Program Development</li>
  <li>Quality of Teaching & Learning</li>
  <li>Faculty Training & Support</li>
  <li>Student Development & Support</li>
  <li>Academic Policies & Standards</li>
  <li>Innovation & Research</li>
</ul>
What makes her training different is the personal attention given to every learner. She doesn’t just teach English—she helps students <b>think in English, express clearly, and build the confidence to succeed</b> in real-world situations.<br/><br/>

In addition, she also worked as a <b>freelance translator, interpreter, and copywriter, offering services</b> in translating educational and general content with accuracy and cultural sensitivity.</>
  },
  gopal: {
    name: "Gopal Lingsur",
     designation: "Co - Founder",
    content: <><b>Gopal Lingsur</b>, the <b>Managing Director</b> of NewZeal Language Academy, brings with him 3 decades of professional experience across IT, Consulting, and Education. He has held leadership positions in globally renowned IT organizations such as <b>Microsoft, Oracle, ThoughtWorks, Sonata Software, etc,</b> where he specialized in <b>Software Testing & Project delivery.</b> <br/><br/>

His diverse background in <b>training, consulting, and management</b> has shaped his passion for education and language learning. At NewZeal, he combines his expertise in <b>strategic planning, process improvement, and people development</b> to create a learning environment that is both <b>professional and student-focused</b>.
<br/><br/>
<b>Gopal is Responsible for the following areas of NewZeal:</b><br/>
<ul>
  <li>Strategic Leadership to grow the business</li>
  <li>Team & Faculty Management</li>
  <li>Student Success & Experience</li>
  <li>Business development </li>
  <li>Operations, including finance, accounting and administration</li>
  <li>Community & Brand Building</li>
</ul><br/><br/>

With a strong foundation in <b>mentorship, corporate training, and academic coaching,</b> he is dedicated to ensuring that every learner at NewZeal achieves success with confidence and clarity.</>
  }
};

const OurStory = () => {
  return (
    <section className="os-section">
      <div className="os-text">
        <h2 className="os-title">Our Leadership</h2>
        <p className="os-description">
          We started with a basic question: Why should learning English depend
          on where you live, how much you can pay, or old-fashioned methods?
          Too many students were stuck using dull books, following rigid
          schedules, and dealing with teachers who focused on theory rather
          than real communication.
        </p>
      </div>

      <div className="os-images">
        <div className="os-card">
          <img src={img1} alt="Tejaswini" />
          <h3>{profiles.tejaswini.name}</h3>
          <h5>{profiles.tejaswini.designation}</h5>
          <p>{profiles.tejaswini.content}</p>
        </div>

        <div className="os-card">
          <img src={img2} alt="Gopal" />
          <h3>{profiles.gopal.name}</h3>
           <h5 className="designation">{profiles.gopal.designation}</h5>
          <p>{profiles.gopal.content}</p>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
